import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../../api/authApi';
import { useAuth } from '../../context/AuthContext';

export default function GoogleLoginCallback() {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    async function complete() {
      try {
        const params = new URLSearchParams(window.location.hash.substring(1));
        const idToken = params.get('id_token');
        const nonce = sessionStorage.getItem('google_nonce');

        if (!idToken || !nonce) {
          throw new Error('Google authentication failed.');
        }

        sessionStorage.removeItem('google_nonce');
        const res = await authApi.googleLogin(idToken);
        login(res.token, res.user, res.subscription);

        navigate('/', { replace: true });
      } catch {
        navigate('/login', {
          replace: true,
        });
      }
    }

    void complete();
  }, [login, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      Signing in with Google...
    </div>
  );
}